import { FrontendHealthCheck } from './child/FrontendHealthCheck';
import { DatabaseHealthCheck } from './child/DatabaseHealthCheck';
import { LogHealthCheck } from './child/LogHealthCheck';
import { SMTPHealthCheck } from './child/SMTPHealthCheck';
import { UploadHealthCheck } from './child/UploadHealthCheck';
import { MasterLayout, MainLayout, ToolbarLayout, ToolbarLayoutLeft, ToolbarLayoutRight } from 'common/imports/content-layout';
import { NoSQLDatabaseHealthCheck } from './child/NoSQLDatabaseHealthCheck';
import { VersionHealthCheck } from './child/VersionHealthCheck';

export function HealthCheck() {
  
  return (
    <>
      <MasterLayout>
        <ToolbarLayout>
          <ToolbarLayoutLeft />
          <ToolbarLayoutRight>
          </ToolbarLayoutRight>
        </ToolbarLayout>
        <MainLayout>
          <VersionHealthCheck />
          <FrontendHealthCheck />
          <DatabaseHealthCheck />
          <NoSQLDatabaseHealthCheck />
          <LogHealthCheck />
          <SMTPHealthCheck />
          <UploadHealthCheck />
        </MainLayout>
      </MasterLayout>
    </>
  );
}
